import React from "react";
import TokenBox from "../../TokenBox";

const Screen43 = () => {
  return <TokenBox />;
};

export default Screen43;
